export default "__VITE_PUBLIC_ASSET__921b98d5__"